import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import Home from "./Gateway/Home";
import HomePage from "./Gateway";
import ComfirmationPayment from "./Gateway/ComfirmationPayment";
import InsuranceInfo from "./Gateway/InsuranceInfo";
import PayWithCard from "./Gateway/PayWithCard";
import TermsAndConditions from "./Gateway/TermsAndConditions";
function App() {
  

  return (
    <Routes>
       <Route element={<HomePage />} path="/gateway" />
      <Route element={<Home />} path="/gateway/installment" />
      <Route element={<ComfirmationPayment />} path="/gateway/card/continue" />
      <Route element={<InsuranceInfo />} path="/gateway/detail" />
      <Route element={<PayWithCard />} path="/gateway/card" />
      <Route element={<TermsAndConditions />} path="/terms-and-conditions" />
      <Route path="*" element={<Navigate to="/gateway" />} />
    </Routes>
  );
}

export default App;
